import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { GetAnfrageByIdResolver } from "../resolver/anfrage/get-anfrage-by-id.resolver";
import { PaymentComponent } from "../features/funds/payment/payment.component";
import { GetAllAnfrageFundingAmountsResolver } from "../resolver/funds/get-all-anfrage-funding-amounts.resolver";
import { FundingAmountComponent } from "../features/funds/funding-amount/funding-amount.component";

export class FundsRoutingFactory extends BaseRoutingFactory {
    private readonly coreFundsRoute: Routes = [
        {
            path: ':scope/:id',
            resolve: {
                anfrage: GetAnfrageByIdResolver,
            },
            children: [
                {
                    path: 'payment',
                    component: PaymentComponent,
                    resolve: {
                        fundingAmounts: GetAllAnfrageFundingAmountsResolver,
                    },
                },
                {
                    path: 'funding-amount',
                    component: FundingAmountComponent,
                    resolve: {
                        fundingAmounts: GetAllAnfrageFundingAmountsResolver,
                    },
                },
            ]
        }
    ];

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }
    
    protected get coreRoute(): Routes {
        return this.coreFundsRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    }
    
}